import Vue from 'vue'
import myrouter from './router/index.js'
import store from './store/index.js'
import CommonFun from './commontools/CommonFun.js'
import enums from './commontools/enums.js'
import myglobal from './commontools/MyGlobal.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import moment from 'moment'
import './assets/css/mystyle.css'
import './commontools/directives.js'
// import echarts from 'echarts'
Vue.use(ElementUI)
Vue.prototype.CommonFun = CommonFun;
Vue.prototype.$enums = enums;
Vue.prototype.$myglobal = myglobal;
Vue.prototype.$moment = moment;
new Vue({
	store,
  render: h => h(App),
  router: myrouter,
  
}).$mount('#app')
